import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


export default class DateInput extends PureComponent {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func
  };

  render() {
    let {value, onChange} = this.props;

    return (
      <DatePicker
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
          selected={value}
          onChange={onChange} />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/DateInput.js